/**
 * All rights Reserved, Designed By www.feidai.com
 * @Title:  iousServices.ts
 * @Package :
 * @author:青瞳科技
 * @date:   2022/1/19 11:32
 * @version V1.0
 * @Copyright: 2020 https://www.feisuan.com Inc. All rights reserved.
 * @Belong To: 青瞳科技
 * 注意：本内容仅限于深圳青瞳科技有限公司内部传阅，除非适用法律要求或书面同意，禁止外泄以及用于其他的商业目的
 */

import {axiosAPIUrl, Parameter, assignParams} from "./index";

export class SupplementPersonInfo {
    /* 现居住地址 */
    currentAddress: string;
    /* 紧急联系人姓名1 */
    emergencyName: string;
    /* 紧急联系人电话1 */
    emergencyPhone: string;
    /* 紧急联系人姓名2 */
    emergencyName1: string;
    /* 紧急联系人电话2 */
    emergencyPhone1: string;
    /* 文化程度 */
    educationList: EducationListDto[];
    /* 婚姻状况 */
    marriageList: MarriageListDto[]
}

export class EducationListDto {
    educationId?: string;
    educationName?: string;
}

export class MarriageListDto {
    marriageId?: string;
    marriageName?: string;
}

export class PayNoteDto {
    nodeId?: string;
    orderMoney?: string;
    msg?: boolean;
}

export class LoanInfoDto {
    repayMethod?: any;
    principal?: any;
    interestAll?: any;
    periods?: any;
}

export class toQuotaResDto {
    /* 接收标识 */
    sendFlag?: string;
    /* 免登url */
    redirectUrl?: string;
    /* 产业通客户编号 */
    cytUserId?: string;
    /* 合作方企业编号 */
    companyId?: string;
    /* 客户编号 */
    merchantId?: string;
    /* 飞贷客户编号 */
    fdUserId?: string;
}
export type FinanceInfo = {
  whiteStrips?: string // 白条权限状态
  leftMoney?: string // 用户剩余额度
  applyMoney?: string // 用户额度
  cashedMoney?: string // 用户已使用额度
  nowTime?: string // 核算系统当前时间
  nowDateYM?: string // 核算系统当前时间的年和月
  showTotalMoney?: string // 还款计划展示金额
}
/**
 * 1.6 订单完成通知状态修改(setOrderNotice)
 * @param orderId
 */
export function setOrderNotice (data: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response>({
    url: '/cykjStoreFinance/WSA/setOrderNotice',
    method: 'post',
    data
  })
}

/**
 * @description: 判断是否获取金融服务权限
 * @param {Parameter} params
 * @return {*}
 */
export function getFinanceAuthority (params: Parameter = {}) {
    return axiosAPIUrl<Ajax.Response>({
      url: '/cykjStoreFinance/WSA/getFinanceAuthority',
      method: 'get',
      params: { ...assignParams(), ...params },
      extraParams: { showLoading: false }
    })
}

/**
 * @description: 判断是否能跳转白条快付权限
 * @param {Parameter} params
 * @return {*}
 */
export function getStatus (params: Parameter = {}) {
    return axiosAPIUrl<Ajax.Response>({
      url: '/cykjStoreFinance/WSA/status',
      method: 'get',
      params: { ...assignParams(), ...params }
    })
}

/**
 * @description: 获取白条快付信息
 * @param {Parameter} params
 * @return {*}
 */
export function getFDwhiteAuthority (params: Parameter = {}) {
    return axiosAPIUrl<Ajax.Response>({
      url: '/cykjStoreFinance/WSA/getFDwhiteAuthority',
      method: 'get',
      params: { ...assignParams(), ...params }
    })
}

/**
 * @description: 获取白条支付节点
 * @param {Parameter} params
 * @return {*}
 */
export function getFDwhiteNode (params: Parameter = {}) {
    return axiosAPIUrl<Ajax.Response>({
      url: '/cykjStoreFinance/WSA/getFDwhiteNode',
      method: 'get',
      params: { ...params },
      extraParams: { showLoading: false }
    })
}

/**
 * @description: 判断合作方是否有免息权限
 * @param {Parameter} params
 * @return {*}
 */
export function getInterestFree (params: Parameter = {}) {
    return axiosAPIUrl<Ajax.Response>({
      url: '/cykjStoreFinance/IM/getInterestFree',
      method: 'get',
      params: { ...params }
    })
}

/**
 * @description: 获取合作方免息权益说明
 * @param {Parameter} params
 * @return {*}
 */
export function getRegulations (params: Parameter = {}) {
    return axiosAPIUrl<Ajax.Response>({
      url: '/cykjStoreFinance/IM/getRegulations',
      method: 'get',
      params: { ...params }
    })
}

/**
 * @description: 白条分期信息
 * @param {Parameter} params
 * @return {*}
 */
export function getLoanTrial(parameter: Parameter = {}) {
    return axiosAPIUrl<Ajax.Response>({
        url: "/cykjStoreFinance/FDA/getLoanTrial",
        method: "post",
        data: { ...assignParams(), ...parameter}
    });
}

/**
 * @description: 飞贷免登录url
 * @param {Parameter} params
 * @return {*}
 */
export function getAvoidLoginUrl(parameter: Parameter = {}) {
    return axiosAPIUrl<Ajax.Response>({
        url: "/cykjStoreFinance/FDA/getAvoidLoginUrl",
        method: "post",
        data: { ...assignParams(), ...parameter },
        extraParams: { showLoading: false }
    });
}

/**
 * @description: 白条支付
 * @param {Parameter} params
 * @return {*}
 */
export function payStoreOrderWhite(parameter: Parameter = {}) {
    return axiosAPIUrl<Ajax.Response>({
        url: "/StoreOrder/SYTS/payStoreOrderWhite",
        method: "post",
        data: {...parameter}
    });
}

/**
 * @description: 线下支付
 * @param {Parameter} params
 * @return {*}
 */
export function payStoreOrderOffline(parameter: Parameter = {}) {
    return axiosAPIUrl<Ajax.Response>({
        url: "/StoreOrder/SYTS/payStoreOrderOffline",
        method: "post",
        data: {...parameter}
    });
}

/**
 * @description: 重置线下支付
 * @param {Parameter} params
 * @return {*}
 */
export function resetStoreOrderOffline(parameter: Parameter = {}) {
    return axiosAPIUrl<Ajax.Response>({
        url: "/StoreOrder/SYTS/resetStoreOrderOffline",
        method: "post",
        data: {...parameter}
    });
}

/**
 * @description: 签署信息授权书记录
 * @param {Parameter} params
 * @return {*}
 */
export function addWhiteSign(parameter: Parameter = {}) {
    return axiosAPIUrl<Ajax.Response>({
        url: "/cykjStoreFinance/WSA/addWhiteSign",
        method: "post",
        data: {...parameter}
    });
}

/**
 * @description: 获取信息授权书记录
 * @param {Parameter} params
 * @return {*}
 */
export function getWhiteSign(parameter: Parameter = {}) {
    return axiosAPIUrl<Ajax.Response>({
        url: "/cykjStoreFinance/WSA/getWhiteSign",
        method: "post",
        data: {...parameter},
        extraParams: { showLoading: false }
    });
}

/**
 * 去出额
 * @param parameter
 */
export function jump2Quota(parameter: Parameter = {}) {
    return axiosAPIUrl<Ajax.Response<toQuotaResDto>>({
        url: "/cykjmerchantsborrower/companyOperations/jump2Quota",
        method: "post",
        data: {...assignParams(), ...parameter}
    });
}

/**
 * 去还款
 * @param parameter
 */
export function jump2Repayment(parameter: Parameter = {}) {
    return axiosAPIUrl<Ajax.Response<toQuotaResDto>>({
        url: "/cykjmerchantsborrower/companyOperations/jump2Repayment",
        method: "post",
        data: {...assignParams(), ...parameter}
    });
}

/**
 * 判断用户是否绑定手机号
 * @param parameter
 */
export function checkUserBindMobile(parameter: Parameter = {}) {
    return axiosAPIUrl<Ajax.Response>({
        url: "/cykjmerchantsborrower/companyOperations/checkUserBindMobile",
        method: "post",
        data: parameter
    });
}

/* 提交借款申请 */
export function submitLoanOrder(parameter: Parameter = {}) {
    return axiosAPIUrl<Ajax.Response<toQuotaResDto>>({
        url: "/cykjmerchantsborrower/companyOperations/submitLoanOrder",
        method: "post",
        data: parameter,
    });
}
/** 2.10 获取合作方受托支付帐户列表(getPartnerPayAcctList)  */
export function getPartnerPayAcctList(parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response<any>>({
      url: "/cykjStoreFinance/AMA/getPartnerPayAcctList",
      method: "get",
      params: parameter,
  });
}

/**
 * 1.7 获取B类客户是否弹窗提示(getWhiteNoticeB)
 */
export function getWhiteNoticeB(parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response<any>>({
      url: "/cykjStoreFinance/WSA/getWhiteNoticeB",
      method: "get",
      params: parameter,
      extraParams: { showLoading: false }
  });
}

/**
 * 1.8 B类客户完成通知状态修改(setWhiteNoticeB)
 */
export function setWhiteNoticeB(parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response<any>>({
      url: "/cykjStoreFinance/WSA/setWhiteNoticeB",
      method: "post",
      data: parameter,
  });
}

/**
 * 1.9 获取B类客户激活提示(getWhiteActivationTip)
 */
export function getWhiteActivationTip(parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response<any>>({
      url: "/cykjStoreFinance/WSA/getWhiteActivationTip",
      method: "get",
      params: parameter,
  });
}

/**
 * 1.10 工作台获取白条信息 getFinanceInfo
 */
export function getFinanceInfo(parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response<any>>({
      url: "/cykjStoreFinance/WSA/getFinanceInfo",
      method: "get",
      params: parameter,
      extraParams: { showLoading: false }
  });
}
